import { Site } from '@envato/foundation-types'
import * as React from 'react'

import DefaultListing from './default'
import PhotoduneListing from './photodune/gridContainer'

import { IEnhancedLocation } from '../../../common/reducers/reactRouterLocation'
import { IItem } from '../../../typings/searchResults'

export interface IItemsListing {
  items: IItem[]
  location: IEnhancedLocation
  currentSite: Site
  viewType?: string
  showSingleRow?: boolean
}

const ItemsListing = ({
  items,
  location,
  currentSite,
  viewType,
  showSingleRow
}: IItemsListing) => {
  const config = {
    [Site.photodune]: PhotoduneListing
  } as any

  const Listing = config[currentSite] || DefaultListing

  return (
    <Listing
      items={items}
      location={location}
      currentSite={currentSite}
      viewType={viewType}
      showSingleRow={showSingleRow}
    />
  )
}

export default ItemsListing
